export function ProcessingOverlay({ isVisible }) {
  if (!isVisible) return null;
  
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[100] flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-2xl p-8 mx-4 max-w-md text-center">
        <div className="relative w-16 h-16 mx-auto mb-4">
          <div className="absolute inset-0 border-4 border-gray-200 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-[#6A7359] rounded-full border-t-transparent animate-spin"></div>
        </div>
        <h3 className="text-xl font-semibold text-[#1A1A1A] mb-2">Generating Your Quote</h3>
        <div className="flex justify-center gap-1 mt-4">
          <span className="w-2 h-2 bg-[#6A7359] rounded-full animate-bounce" style={{animationDelay: "0s"}}></span>
          <span className="w-2 h-2 bg-[#6A7359] rounded-full animate-bounce" style={{animationDelay: "0.15s"}}></span>
          <span className="w-2 h-2 bg-[#6A7359] rounded-full animate-bounce" style={{animationDelay: "0.3s"}}></span>
        </div>
      </div>
    </div>
  );
}
